export const projectTypeTranslationMap = {
  AdTestingTypeName: 'Product Ad Testing',
  AdvertisingPreTestTypeName: 'Advertising Creative Testing',
  AgileVideoDiscoveryTypeName: 'Agile Video Discovery',
  AppInsights: 'App Insights',
  AttitudeAndUsageTypeName: 'Attitude & Usage',
  AudienceManagement: 'Audience Management',
  Barometer: 'Barometer',
  BaseProgram: 'Customer experience program',
  BasicSurveyProjectName: 'Simple Survey',
  BenefitsOptimizer: 'Benefits Optimizer',
  BenefitsPerksTypeName: 'Benefits & Perks',
  BlankProjectDescription:
    'Start with a blank survey project and build it to suit your needs.',
  BlankProjectName: 'Blank Project',
  BrandAwarenessTypeName: 'Brand Awareness & Performance',
  BrandDiagnosticTypeName: 'Brand Diagnostic',
  BrandExperienceProject: 'Brand Experience Project',
  BrandPerceptionTypeName: 'Brand Perceptions',
  BrandTracker: 'Brand Tracker',
  BrandTrackerTypeName: 'Brand Tracker',
  BrandTrustPulseTypeName: 'COVID-19 Brand Trust Pulse',
  CallCenterAssistantTypeName: 'COVID-19 Dynamic Call Center Script',
  CandidateExperience: 'Candidate Experience',
  CardSortTypeName: 'Product Optimization (Card Sort)',
  ChangeManagementTypeName: 'Change Management',
  ChobaniProductTestTypeName: 'Chobani Product Test',
  CoachingRecommendationsProject: 'AI Coaching Recommendations',
  ConceptOptimization: 'Concept Optimization',
  ConceptTestingProgram: 'Concept Testing Program',
  ConceptTestingTypeName: 'Product Concept Testing',
  ConceptTestingV2: 'Concept Testing',
  Conjoint: 'Conjoint',
  ConjointDynamicImages: 'Conjoint Dynamic Images',
  ConjointProjectDescription:
    'Conduct a conjoint analysis for feature selection or determining the optimum package, by measuring propensity to pay, relative feature importance and a host of other customer preferences.',
  ConjointProjectName: 'Product Optimization (Conjoint)',
  ConjointTypeName: 'Conjoint',
  CoreXMProject: 'CoreXM Project',
  CourseEvaluations: 'Course Evaluations',
  CreativeTestingTypeName: 'Creative Testing',
  CrossXMAnalytics: 'CrossXM Analytics',
  CustomerConfidencePulseTypeName: 'Customer Confidence Pulse',
  CustomerEffortScoreTypeName: 'Transactional Customer Effort Score (CES)',
  CustomerExperienceProject: 'Customer Experience Project',
  CustomerFeedbackProjectDescription:
    'Collect industry specific customer feedback using Bain certified Net Promoter® Score methodology.',
  CustomerPulseTypeName: 'COVID-19 Customer Confidence Pulse',
  CustomerSatisfactionScoreTypeName: 'Customer Satisfaction (CSAT)',
  CustomizableProject: 'Customizable Project',
  Dashboard: 'Dashboard',
  DigitalAdvertisingBrandLiftTypeName: 'Digital Advertising Brand Lift',
  DigitalExperience: 'Digital Experience',
  DigitalJourneyOptimization: 'Digital Journey Optimization',
  DigitalOpenDoorTypeName: 'Digital Open Door',
  DigitalSupportOptimization: 'Digital Support Optimization',
  DigitalXMSolutionForGovernment: 'Digital Journey Solution for Government',
  DistinctiveAssetsTypeName: 'Distinctive Assets',
  DiversityAndInclusionTypeName: 'Diversity & Inclusion',
  EEProjectDescription:
    'Empower every leader in your organization with insights on the engagement of their workforce, drivers that will have the most impact on employee engagement, and action planning tools to drive improvement.',
  EEProjectName: 'Employee Engagement',
  EETypeName: 'Engagement',
  ELCProgram: 'Employee Lifecycle Program',
  EXCovidSolution_RtWTypeName: 'Return to Work Pulse 2.0',
  EdSchoolHomeTypeName: 'K-12 Education: Remote Learning Pulse',
  EdTeachHomeTypeName: 'Remote Educator Pulse',
  EmployeeAdHoc: 'Employee Ad Hoc',
  EmployeeAdHocProjectDescription:
    'Perform impromptu research to quickly gauge employee feedback and share it with your team.',
  EmployeeAdHocProjectName: 'Employee Ad Hoc',
  EmployeeAdHocTypeName: 'Ad Hoc Employee Research',
  EmployeeEngagement: 'Employee Engagement',
  EmployeeExperienceProject: 'Employee Experience Project',
  EmployeeFeedbackProjectDescription:
    'Measure how engaged your employees are and the reasons behind it. With this project, our experts will get you started on the path to building a great place to work!',
  EmployeeLed360: 'Employee Led 360',
  EmployeeLifecycle: 'Employee Lifecycle',
  EmployeeLifecycleProjectDescription:
    'Continuously measure and act on employee feedback across lifecycle touch points such as onboarding and exit.',
  EmployeeLifecycleProjectName: 'Employee Lifecycle',
  EmployeeLifecycleTypeName: 'Lifecycle',
  EmployeePulse: 'Employee Pulse',
  EmployeePulseProjectDescription:
    'Quickly gather a snapshot of your workforce with surveys repeated at regular intervals.',
  EmployeePulseProjectName: 'Employee Pulse',
  EmployeePulseTypeName: 'Pulse',
  EventFeedbackTypeName: 'Event Feedback',
  ExperienceTransparency: 'Experience Transparency',
  FFTFEmployeeGivingTypeName: '5FTF Employee Giving',
  FeatureAwarenessTypeName: 'Feature Awareness',
  FeatureRequest: 'Frontline Feedback',
  FeatureRequestProjectDescription:
    'Collect, organize and prioritize feedback and requests from frontline employees. Prioritization of requests is enabled via sorting, filtering, searching and custom lists.',
  FeatureRequestProjectName: 'Frontline Feedback',
  FeatureRequestTypeName: 'Frontline Feedback',
  FrequentPulse: 'Pulse',
  FrontlineFeedbackSolutionTypeName: 'Frontline Connect',
  GaborGrangerPriceSensitivityTypeName: 'Pricing Study (Gabor Granger)',
  GlobalBrandTracker: 'Multi-Category Brand Tracker',
  GuidedFAQTypeName: 'Public Health: COVID-19 Pre-Screen & Routing',
  HealthcareWorkPulseTypeName: 'Healthcare Workforce Pulse',
  HighEdSchoolHomeTypeName: 'Higher Education: Remote Learning Pulse',
  IBMEmployeeXMforIT: 'IBM Employee XM for IT',
  IdeaScreening: 'Idea Screening',
  ImportedDataProjectDescription:
    'Upload data to Qualtrics (e.g. to analyze with Stats iQ)',
  ImportedDataProjectName: 'Imported Data',
  ImportedDataTypeName: 'Imported Data',
  ImportedVideoData: 'Imported Audio and Video',
  InAppUXOptimization: 'In-App UX Optimization',
  KanoAnalysisTypeName: 'Kano Analysis',
  ManagerFeedbackTypeName: 'Manager Feedback (eNPS)',
  ManagerLedSurveys: 'Manager Led Surveys',
  MaxDiff: 'MaxDiff',
  MaxDiffDescription:
    'Conduct a MaxDiff analysis to understand the priority and importance that customers assign to product features or attributes.',
  MaxDiffProjectName: 'Product Prioritization (MaxDiff)',
  MaxDiffTypeName: 'MaxDiff',
  ModeratedUserTesting: 'Moderated User Testing',
  NeedsBasedTypeName: 'Needs-Based Analysis',
  NewBasicSurveyProjectName: 'Blank Survey Project',
  NewConjointProjectName: 'Conjoint',
  NewEEProjectName: 'Blank Engagement Project',
  NewEmployeeAdHocProjectName: 'Blank Ad Hoc Project',
  NewEmployeeLifecycleProjectName: 'Blank Lifecycle Project',
  NewEmployeePulseProjectName: 'Blank Pulse Project',
  NewFeatureRequestProjectName: 'Frontline Feedback',
  NewImportedDataProjectName: 'Imported Data Project',
  NewSIProjectName: 'Blank Website / App Feedback',
  NewThreeSixtyProjectName: 'Blank 360 Project',
  NewVOCProjectName: 'Blank Dashboard Project',
  Nominations: 'Nominations',
  OXMChatProject: 'Chat Data',
  OXMEmailProject: 'Email Data',
  OnlineReputationManagement: 'Online Reputation Management',
  PatientExperience: 'Patient Experience',
  ProductExperienceProject: 'Product Experience Project',
  ProductNamingTypeName: 'Product Naming',
  ProductSatisfactionTypeName: 'Product Satisfaction',
  ProductTesting: 'Product Testing',
  ProductTestingScreenerSurvey: 'Product Testing Screener Survey',
  ProductTestingSurvey: 'Product Testing Survey',
  RelationalNPSTypeName: 'Relationship NPS',
  RemoteWorkPulseTypeName: 'Remote + On-site Work Pulse',
  ResearchCoreProject: 'CoreXM Project',
  ResearchSurvey: 'Research Survey',
  RetailBankingSolution: 'Retail Banking Accelerator',
  ReturnToWorkPulseTypeName: 'Return to Work Pulse',
  SIEXProjectDescription:
    'Listen for employee feedback through always-on touchpoints within your internal websites and apps.',
  SIProjectDescription:
    'Measure the digital experience and deliver targeted, personalized content.',
  SIProjectName: 'Website / App Feedback',
  SelfEvaluations: 'Self Evaluations',
  ServiceDesk: 'Service Desk',
  Survey: 'Survey',
  SimpleSurvey: 'Simple Survey',
  SiteInterceptProjectType: 'Website / App Insights',
  SupplierContPulseTypeName: 'Supplier Continuity Pulse',
  TeamEventFeedbackTypeName: 'Team Event Feedback',
  ThreeSixty: '360',
  ThreeSixtyProjectDescription:
    'Conduct 360 assessments with flexible form development, real-time reports, and process management.',
  ThreeSixtyProjectName: 'Employee 360',
  TicketsFollowUpDetailsTypeName: 'Ticket feedback',
  TrainingFeedbackTypeName: 'Training Feedback',
  TransactionalNPSTypeName: 'Touchpoint NPS (Transactional NPS)',
  UnmoderatedUserTesting: 'Unmoderated User Testing',
  VOCProjectDescription:
    "Make sense of what's going on with configurable dashboards for every role and relevant insights for the right people to see.",
  VOCProjectDisplayName: 'Dashboards',
  VOCProjectName: 'Dashboards Project',
  VaccinationStatusManager: 'Vaccination Status Manager',
  VanWestendorpPriceSensitivityMeterTypeName: 'Pricing Study (Van Westendorp)',
  Vocalize: 'CX Dashboards',
  WebUXOptimization: 'Web UX Optimization',
  XMProject: 'XM Project',
  ZeroPartyData: 'Customer Preference Collection',
  amazontastetestTypeName: 'Taste Test',
  crayolaconcepttestTypeName: 'Crayola Concept Test',
  demosolutionTypeName: 'Demo Solution',
  nba_teameffectivenessTypeName: 'NBA Team Effectiveness',
  woolworths_concepttestTypeName: 'Woolworths Concept Test',
};
